import React from 'react'
import AppFrame from '../AppFrame'

export default ({globalData}) => {
  return (
    <AppFrame data={globalData}>
      <div className="min-h-screen">
        locations
      </div>
    </AppFrame>
  )

}